<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="pageinfo.banner" /></div>
        </div>
        <div class="navinfowconrap">
            <div class="navinfocon realwrap editor2"><img :src="voiceimg" style="width:100%" /></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {
                pageinfo: {},
                voiceimg: '',
            };
        },
        mounted() {
            let imgalias = 'tc_voice' + this.$store.getters.tctype || 0;
            this.$common.fetch({ 'act': 'common_infoimg', 'exts': 'alias=' + imgalias }, res => {
                this.voiceimg = res.infodata.imgs;
            });

            this.$common.fetch({ 'act': 'tc_topnavinfo', 'exts': 'id=5' }, res => {
                this.pageinfo = res.infodata;
            });
        }

    }
</script>
